import { createModeratorApiClient } from '../utils/apiClient';

/** Moderator client API key auth — same as /topics/, /buzzwords/. */
const mod = createModeratorApiClient();

export const subscribersApi = {
  /**
   * @param {{ skip?: number; limit?: number; search?: string; signal?: AbortSignal }} [opts]
   */
  list: (opts = {}) => {
    const { signal, ...params } = opts;
    return mod.get('/subscribers/', { params, signal });
  },

  /**
   * Create a subscriber, then optionally assign topics in a second call.
   * Use createWithTopics for a single-round-trip version.
   * @param {{ mail: string; username: string; password?: string; language?: 'de'|'en'|'vi'|'fr' }} body
   */
  create: (body) => mod.post('/subscribers/', body),

  /**
   * Create subscriber and assign topic IDs in one call.
   * @param {{ mail: string; username: string; topic_ids?: number[]; language?: 'de'|'en'|'vi'|'fr' }} body
   */
  createWithTopics: (body) => mod.post('/subscribers/with-topics', body),

  /** @param {number} id */
  get: (id) => mod.get(`/subscribers/${id}`),

  /**
   * @param {number} id
   * @param {{ mail?: string; username?: string; topic_ids?: number[]; language?: 'de'|'en'|'vi'|'fr' }} body
   */
  update: (id, body) => mod.put(`/subscribers/${id}`, body),

  /** @param {number} id */
  remove: (id) => mod.delete(`/subscribers/${id}`),

  /**
   * Set / reset subscriber password.
   * @param {number} id
   * @param {{ password: string }} body — min 8 chars
   */
  setPassword: (id, body) => mod.post(`/subscribers/${id}/set-password`, body),
};
